import React from 'react';
import { SensordataSTChartLine } from '../../../../../../../redux/monitoring/api/monitoring.model';
import {
  STTimeLineChartData,
  TimeFrame,
} from '../../../../../../../redux/monitoring/api/monitoring-ui.model';
import AnalogTable from './AnalogTable';
import { Box, Tab, Tabs } from '@mui/material';
import { getPolyglot } from '../../../../../../../i18n';
import DigitalTable from './DigitalTable';
import DigitalSeriesTable from './DigitalSeriesTable';

interface MonitoringTablesProps {
  sensordata: SensordataSTChartLine[];
  digitalChannels: STTimeLineChartData;
  timeFrame: TimeFrame;
}
// render a MUI tabs component with two tabs: Analog and Digital
// the Analog tab will render the AnalogTable component
// the Digital tab will render the DigitalChannels component
function MonitoringTables({
  sensordata,
  digitalChannels,
  timeFrame,
}: MonitoringTablesProps) {
  const polyglot = getPolyglot();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
      >
        <Tab
          value={0}
          label={polyglot.t('device.monitoring.analog_channels')}
          wrapped
        />
        <Tab
          value={1}
          label={polyglot.t('device.monitoring.digital_channels')}
        />
        <Tab
          value={2}
          label={polyglot.t('device.monitoring.digital_channels') + ' (Series)'}
        />
      </Tabs>
      <Box sx={{ p: 3 }}>
        {value === 0 && <AnalogTable sensordata={sensordata} />}
        {value === 1 && (
          <DigitalTable
            digitalChannels={digitalChannels}
            timeFrame={timeFrame}
          />
        )}
        {value === 2 && (
          <DigitalSeriesTable digitalChannels={digitalChannels} />
        )}
      </Box>
    </Box>
  );
}

export default MonitoringTables;
